/** This round's reveal order: the devil card holder first, then clockwise. */
export function revealOrderFrom(
  seatingOrder: readonly string[],
  devilCardHolderId: string,
): readonly string[] {
  const index = seatingOrder.indexOf(devilCardHolderId);
  if (index === -1)
    throw new Error(`Unknown devil card holder ${devilCardHolderId}`);
  return [...seatingOrder.slice(index), ...seatingOrder.slice(0, index)];
}
